import { render, staticRenderFns } from "./SithMesPrdProjectKamSelection.vue?vue&type=template&id=c816b0e6&scoped=true&"
import script from "./SithMesPrdProjectKamSelection.vue?vue&type=script&lang=js&"
export * from "./SithMesPrdProjectKamSelection.vue?vue&type=script&lang=js&"
import style0 from "./SithMesPrdProjectKamSelection.vue?vue&type=style&index=0&id=c816b0e6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c816b0e6",
  null
  
)

export default component.exports